export default "/images/6385765e242a395091c56382d46f2864.png";